import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'semantic-ui-react';

const BillingDailyDetail = ({ records, configId }) => {
  const { t } = useTranslation();

  const configRecords = (records || []).filter((r) => r.config_id === configId);
  const dailyRecords = configRecords.filter((r) => r.granularity === 'daily');
  const filtered = dailyRecords.length > 0 ? dailyRecords : configRecords;

  if (filtered.length === 0) {
    return <p>{t('channel_billing.daily.no_data', '暂无明细')}</p>;
  }

  return (
    <Table compact size='small'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            {dailyRecords.length > 0
              ? t('channel_billing.daily.date', '日期')
              : t('channel_billing.daily.period', '周期')}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t('channel_billing.daily.granularity', '粒度')}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t('channel_billing.daily.input_tokens', '输入 Token')}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t('channel_billing.daily.output_tokens', '输出 Token')}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t('channel_billing.daily.total_tokens', '总 Token')}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t('channel_billing.daily.calls', '调用次数')}
          </Table.HeaderCell>
          <Table.HeaderCell>消费金额 (CNY)</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {filtered.map((record) => (
          <Table.Row key={record.id}>
            <Table.Cell>{record.bill_date}</Table.Cell>
            <Table.Cell>
              {record.granularity === 'monthly'
                ? t('channel_billing.daily.monthly', '月')
                : t('channel_billing.daily.daily', '日')}
            </Table.Cell>
            <Table.Cell>
              {(record.input_tokens || 0).toLocaleString()}
            </Table.Cell>
            <Table.Cell>
              {(record.output_tokens || 0).toLocaleString()}
            </Table.Cell>
            <Table.Cell>
              {(record.total_tokens || 0).toLocaleString()}
            </Table.Cell>
            <Table.Cell>{(record.call_count || 0).toLocaleString()}</Table.Cell>
            <Table.Cell>
              {Number(record.amount_cny || 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 8,
              })}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default BillingDailyDetail;
